<script setup lang="ts">
import { useProductStore } from '@/stores/products'
import { onMounted} from 'vue'
import {useRoute, useRouter} from "vue-router";


const route = useRoute();
</script>
<template>
  <RouterView />
</template>

<style lang="scss">
@forward 'scss/main.scss';

#app {
  font-family: 'Inter', Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
  margin: 0;
  min-width: 20rem;
}
</style>
